import {
  FilterMode,
  TenantTokenUsage_OrderBy,
  TenantTokenUsage,
  SortOrder,
  TenantTokenUsage_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";

export const tenantTokenUsageService = {
  createOne: () => (): Promise<string> => new Promise(() => ""),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.tenantTokenUsageOne({ id });
    return result.tenantTokenUsageOne as TenantTokenUsage;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: TenantTokenUsage_OrderBy[] | null = null,
    filter: TenantTokenUsage_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: TenantTokenUsage_Filter | undefined;
    if (searchValue !== "") {
      where = { id: { contains: searchValue, mode: FilterMode.Insensitive } };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.tenantTokenUsageListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : { id: SortOrder.Asc },
      where,
    });
    const list = nullToUndefinedRecursive(
      result.tenantTokenUsageListWithOffset
    ) as TenantTokenUsage[];
    return { list, orderBy };
  },
};
